const framesHaveMandatorySentryRedirectProperties = function (
    frames: Array<Record<string, string>>,
): frames is Array<{ dsn: string }> {
    return frames.length && frames.every(({ dsn }) => dsn);
};

export { framesHaveMandatorySentryRedirectProperties };
